import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import SummaryDuty from '@/types/table/summaryDuty';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SummaryDutyData extends SummaryDuty {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SummaryDutyController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryDutyData>>(API_CONTEXT + '/app/summaryDuty/list', params, httpOptions);
  }

  static summaryDutyByCreateUser(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryDutyData>>(API_CONTEXT + '/app/summaryDuty/summaryDutyByCreateUser', params, httpOptions);
  }

  static dutySummaryList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryDutyData>>(API_CONTEXT + '/app/summaryDuty/dutySummaryList', params, httpOptions);
  }
  
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SummaryDutyData>(API_CONTEXT + '/app/summaryDuty/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/summaryDuty/export', params, fileName);
  }

    static exportCreateUserId(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/summaryDuty/exportCreateUserId', params, fileName);
  }


  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/summaryDuty/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/summaryDuty/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryDuty/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryDuty/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryDuty/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/summaryDuty/deleteBatch', params, httpOptions);
  }
  static confirm(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SummaryDutyData>>(API_CONTEXT + '/app/summaryDuty/confirm', params, httpOptions);
  }
}
